/* eslint-disable @typescript-eslint/naming-convention */
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "src/hooks/useAuth";
import NOTIFICATION_FOUND from "src/graphql/subscriptions/chat/notificationFound";
import { useSubscription } from "@apollo/client";
import useSubscriptionCondition from "./subscriptionCondition";
import ScreenLoader from "./screenLoader";

const AuthGuardForSubscription = () => {
  const { loading } = useAuth() as any;

  const redirecToSubscription = useSubscriptionCondition();
  // just for connecting the subscription
  useSubscription(NOTIFICATION_FOUND);

  if (loading) return <ScreenLoader />;

  if (redirecToSubscription) {
    return <Outlet />;
  }

  return <Navigate to="/login" />;
};

export default AuthGuardForSubscription;
